<template>
<div class="desk-phone-row" v-if="value">
  <div class="desk-phone-row__title">
    <span>{{ displayName }}</span>
    <span>{{ $money(currentAmount) }}</span>
  </div>
  <p class="desk-phone-row__desc">{{ $t('billing.hw.desk_phones.config.desk_phone_row.desc') }}</p>
  <div class="desk-phone-row__config-row">
    <input-number-with-popover
      :value="currentLicense"
      @change="handleNumberChange"
      :dataTracking="{
        buyInteraction: 'desk phone',
        buySelection: `desk phone - ${displayName}`
      }"
      size="large"
      controls-position="both"
      :min="1"
      :max="50"
      :increaseTips="``"
      :decreaseTips="``"
      :unit="$t('billing.hw.desk_phones.config.desk_phone_row.unit')"
      :label="`${displayName} quantity`"
    ></input-number-with-popover>

    <zm-button 
      v-if="showRemoveBtn"
      type="link" 
      ghost 
      @click="handleRemoveSelf"
      :aria-label="'remove ' + displayName"
    >{{ $t('billing.common.remove') }}</zm-button>
  </div>
</div>
</template>
<script>
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'DeskPhoneRow',
  components: { InputNumberWithPopover },
  props: {
    value: {
      type: Object,
      default: () => null
    },
    showRemoveBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLicense() {
      return this.value?.cartInfo?.selected_number || 0
    },
    currentAmount() {
      return (this.value?.amount || 0) * this.currentLicense
    },
    displayName() {
      return `${this.value.planName} ${this.$t(this.value.typeNameKey)}`
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'removePlan']),
    handleNumberChange(v) {
      this.updateSelectPlan({
        plan_code: this.value.plan_code,
        cartInfo: { selected_number: v }
      })
    },
    handleRemoveSelf() {
      this.$tracking.buyInteraction('desk phones options', `desk phone - ${this.$t(this.value.typeNameKey)} - remove`);
      this.removePlan(this.value.plan_code)
    }
  }
}
</script>
<style lang="scss">
.desk-phone-row {
  margin-bottom: 24px;
  &__title {
    color: var(--day-foreground-foreground, #00053D);
    /* body/LF — L (R) */
    font-family: "Almaden Sans";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 30px */

    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__desc {
    color: var(--day-foreground-foreground, #00053D);
    /* body/LF — S (R) */
    font-family: "Almaden Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */

    margin-top: 0;
    margin-bottom: 24px;
    padding: 0;
  }
  &__config-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
